import * as React from 'react';

export function MahjongManagerIndex(): JSX.Element {
    return (
        <div className="ma-2 flex-fill">
            <h2 className="white-text">Mahjong Manager</h2>
        </div>
    );
}
